import * as React from 'react';

import { cn } from '@/lib/utils';

function Empty({
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<'div'>) {
  return (
    <div
      ref={ref}
      className={cn(
        'flex w-full flex-col items-center justify-center text-center',
        className
      )}
      {...props}
    />
  );
}
Empty.displayName = 'Empty';

function EmptyHeader({
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<'div'>) {
  return (
    <div
      ref={ref}
      className={cn('flex max-w-lg flex-col items-center gap-3', className)}
      {...props}
    />
  );
}
EmptyHeader.displayName = 'EmptyHeader';

function EmptyMedia({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithRef<'div'>) {
  return (
    <div
      ref={ref}
      className={cn(
        'border-accent-10 bg-accent-1 text-accent-500 relative flex h-16 w-16 items-center justify-center rounded-2xl border',
        '[&_svg]:h-8 [&_svg]:w-8',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
EmptyMedia.displayName = 'EmptyMedia';

function EmptyTitle({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithRef<'h3'>) {
  return (
    <h3
      ref={ref}
      className={cn('text-text-1 text-lg font-semibold', className)}
      {...props}
    >
      {children}
    </h3>
  );
}
EmptyTitle.displayName = 'EmptyTitle';

function EmptyDescription({
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<'p'>) {
  return (
    <p
      ref={ref}
      className={cn('text-text-3 text-sm leading-5', className)}
      {...props}
    />
  );
}
EmptyDescription.displayName = 'EmptyDescription';

function EmptyActions({
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<'div'>) {
  return (
    <div
      ref={ref}
      className={cn(
        'flex w-full flex-col items-stretch justify-center gap-2 pt-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:gap-3 [&>*]:w-full sm:[&>*]:w-auto',
        className
      )}
      {...props}
    />
  );
}
EmptyActions.displayName = 'EmptyActions';

export {
  Empty,
  EmptyActions,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
};
